import _isString from 'lodash/isString';
import { getId } from '../../../foundation/services';
export function getLocationDisplay(location) {
  if (_isString(location)) {
    return location;
  }
  var name = location.name,
    street = location.street,
    city = location.city;
  var locationId = getId(location);
  if (name) {
    return name;
  }
  if (street || city) {
    return [street, city].filter(function (l) {
      return !!l;
    }).join(', ');
  }
  return "Location ".concat(locationId);
}
export function getLocationSelectOptions(locations) {
  return (locations || []).map(function (location) {
    return {
      key: location.id,
      value: location.id,
      text: getLocationDisplay(location)
    };
  });
}